export enum ProjectSettingsAttribute {
  NotForConstructionChopOnTransmittalDrawings = 'NotForConstructionChopOnTransmittalDrawings',
  PrintQROnDrawings = 'PrintQROnDrawings',
  PrintQROnCert = 'PrintQROnCert',
  QualificationOnICEChop = 'QualificationOnICEChop',
  RequiresICEConstructionCert = 'RequiresICEConstructionCert',
  EnableTeam = 'EnableTeam',
  RequiresPDFPageNumber = 'RequiresPDFPageNumber',
  HasExternalPartyAccessControlException = 'HasExternalPartyAccessControlException',
  RequiresICEChopOnT3 = 'RequiresICEChopOnT3',
  LiveDebug = 'LiveDebug',
  UseICETransmittal = 'UseICETransmittal',
  NotTWPWUserSettingsMerged = 'NotTWPWUserSettingsMerged',
  CanUseBulkUpload = 'CanUseBulkUpload',
  TWCanUseBulkUpload = 'TWCanUseBulkUpload',
  PrintICECertifiedDateOnICEChop = 'PrintICECertifiedDateOnICEChop',
  GEMSDailySummary = 'GEMSDailySummary',
  UseOldStyling = 'UseOldStyling',
  UseOldT1 = 'UseOldT1',
  UseOldPdfCopy = 'UseOldPdfCopy',
  ICECertStartFromA = 'ICECertStartFromA',
  DBSecurity = 'DBSecurity',
  EnableAppNotification = 'EnableAppNotification',
  NoOfICEChopInReport = 'NoOfICEChopInReport', // All, False, First (Default)
  RequiresICERemovalCert = 'RequiresICERemovalCert',
  EnableMultipleUnloadCert = 'EnableMultipleUnloadCert',
  ShowT4ConstCertWOICE = 'ShowT4ConstCertWOICE',
  ShowT4RemovalCertWOICE = 'ShowT4RemovalCertWOICE',
  EnableRSSDistributionInIT = 'EnableRSSDistributionInIT',
  EnableT4RSSDistribution = 'EnableT4RSSDistribution',
  RFCDrawingICEBottom = 'RFCDrawingICEBottom',
  RFCDrawingICERight = 'RFCDrawingICERight',
  RFCDrawingRFCBottom = 'RFCDrawingRFCBottom',
  RFCDrawingRFCRight = 'RFCDrawingRFCRight',
  RFCDrawingICETop = 'RFCDrawingICETop',
  RFCDrawingICELeft = 'RFCDrawingICELeft',
  RFCDrawingRFCTop = 'RFCDrawingRFCTop',
  RFCDrawingRFCLeft = 'RFCDrawingRFCLeft',
  T3DrawingT3Top = 'T3DrawingT3Top',
  T3DrawingT3Bottom = 'T3DrawingT3Bottom',
  T3DrawingT3Left = 'T3DrawingT3Left',
  T3DrawingT3Right = 'T3DrawingT3Right',
  NoSignDesignCert = 'NoSignDesignCert',
  NoSignConstructionCert = 'NoSignConstructionCert',
}

export interface IProjectSettings {
  id: number;
  projectId: number;
  attribute: string;
  value: string;
  rowVersion: string;
}
